import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-today-travels',
  templateUrl: './today-travels.component.html',
  styleUrls: ['./today-travels.component.css']
})
export class TodayTravelsComponent implements OnInit {

  travelsDataSource: MatTableDataSource<any>;
  displayedColumns = ['id', 'description', 'initTime', 'customer'];
  reportTitle: string;
  @ViewChild(MatPaginator) travelsPaginator: MatPaginator;
  @ViewChild(MatSort) travelSort: MatSort;
  
  activeTravels: any[] = [
    {
      id: 1,
      initTime: '08:00 am',
      status: 'on time',
      route: {
        description: 'Viaje a Las Terrenas',
      }
    },
    {
      id: 2,
      initTime: '08:00 am',
      status: 'on time',
      route: {
        description: 'Viaje a La Romana',
      }
    },
    {
      id: 3,
      initTime: '08:00 am',
      status: 'late',
      route: {
        description: 'UNPHU - Playa',
      }
    }
  ]

  constructor(
    private dialogRef: MatDialogRef<TodayTravelsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
    this.reportTitle = "Reporte de viajes del dia " + new Date().toDateString();
    console.log('viajes para imprimir', this.data);
  }

  ngAfterViewInit() {
    
    this.travelsDataSource = new MatTableDataSource<any>(this.data);
    // this.travelsDataSource = new MatTableDataSource<any>(this.activeTravels);
    this.travelsDataSource.paginator = this.travelsPaginator;
    this.travelsDataSource.sort = this.travelSort
  }

}
